import { useThemeContext } from '../contexts/theme-context';

export const useGetEnvironment = () => {
  const { isVite, isNextJs, is5ers, isTtp } = useThemeContext();
  return { isVite, isNextJs, is5ers, isTtp };
};
